module.exports = __webpack_public_path__ + "img/wild_west.62b67298.jpg";